const iconWorksReducer = (state, action) => {
    if (Object.keys(state).indexOf(action.type) < 0)
        throw new Error(`Unsupported type: '${action.type}, did you add it in initial state?`);
    let newState = {...state, [action.type]: action.works};
    const index = Object.keys(newState).findIndex(x => x !== 'anyWorks' && newState[x] === true);
    newState.anyWorks = index > -1;
    return newState;
}
export default iconWorksReducer;